const translations = () => {
    return {
        "logo": {
            "1": "./assets/images/logo.png",
            "2": "./assets/images/conexiones.png"
        },
        "alt": {
            "1": "Connections App",
            "2": "Conexiones App"
        },
        "description": {
            "1": "The Connections App offers community, hope, motivation, skill-building, recovery tracking, and, if needed, crisis support, to help individuals achieve their recovery goals.",
            "2": "Únase a la comunidad, participe con sus compañeros (de forma anónima), realice un seguimiento de su recuperación, motívese, aprenda habilidades de afrontamiento y obtenga apoyo 7 días a la semana."
        },
        "companion_description":{
            "1":"The Companion App offers support, information, and resources, to family members and caregivers of individuals with behavioral health issues, including substance use disorder."
        },
        "anonymity": {
            "1": "This app is free; your privacy is protected.",
            "2": "Anonimato protegido; sin costo alguno."
        },
        "fill_form": {
            "1": "Fill in the form below and you will receive a text message invitation with a download link.",
            "2": "Rellene el siguiente formulario y un mensaje de texto irá, inmediatamente, al teléfono del miembro, con un enlace de descarga"
        },
        "staff_enroll_form":{
            "1":"Fill in the form below and a text message invitation, including a download link, will be sent to the individual’s phone."
        },
        "first_name": {
            "1": "First Name",
            "2": "Nombre"
        },
        "last_name": {
            "1": "Last Name",
            "2": "Apellido"
        },
        "date_birth": {
            "1": "Date of Birth",
            "2": "Fecha de nacimiento"
        },
        "first_time_log": {
            "1": "required for first time login",
            "2": "necesario para iniciar sesión por primera vez"
        },
        "phone": {
            "1": "Mobile Phone Number",
            "2": "Número de teléfono móvil"
        },
        "gender": {
            "1": "Gender",
            "2": "Género"
        },
        "male": {
            "1": "Male",
            "2": "Hombre"
        },
        "female": {
            "1": "Female",
            "2": "Mujer"
        },
        "other": {
            "1": "Prefer not to respond",
            "2": "Prefiero no responder"
        },
        "transgender": {
            "1": "Transgender",
            "2": "Transgénero"
        },
        "nonbinary": {
            "1": "Non-binary",
            "2": "No binario"
        },
        "email": {
            "1": "Email Address",
            "2": "Dirección de correo electrónico"
        },
        "optional": {
            "1": "(optional)",
            "2": "(opcional)"
        },
        "questions": {
            "1": "Have questions? Need help? Email",
            "2": "¿Tiene preguntas? ¿Necesita ayuda? Envíe un correo electrónico a"
        },
        "text_sent": {
            "1": "Enrolled! Text Message Sent.",
            "2": "¡Inscrito! Mensaje de texto enviado."
        },
        "smartphone_download_now": {
            "1": "If you're on your smartphone, download now",
            "2": "Si estás usando tu telefono, descárgala ahora"
        },
        "email_download": {
            "1": "Email with download link has also been sent to",
            "2": "Se ha enviado un correo electrónico con el enlace de descarga a"
        },
        "temporary_password":{
            "1":"Temporary Password:",
            "2":"Contraseña temporal:"
        },
        "created_title": {
            "1": "Patient Created",
            "2": "El paciente fue creado"
        },
        "created_desc": {
            "1": "Patient was successfully created.",
            "2": "La paciente se creó con éxito."
        },
        "privacy_policy": {
            "1":"Privacy Policy",
            "2":"Política de Privacidad"
        },
        "submit": {
            "1":"Submit",
            "2":"Enviar"
        },
        "close": {
            "1":"Close",
            "2":"Cerrar"
        },
        "race": {
            "1":"Race",
            "2":"Raza"
        },
        "white": {
            "1":"White",
            "2":"Blanco"
        },
        "hispanic": {
            "1":"Hispanic or Latino",
            "2":"Hispano o Latino"
        },
        "black": {
            "1":"Black or African American",
            "2":"Negro o Afroamericano"
        },
        "native": {
            "1":"Native American or American Indian",
            "2":"Nativo Americano o Indio Americano"
        },
        "asian": {
            "1":"Asian / Pacific Islander",
            "2":"Asiático / Isleño del Pacífico"
        },
        "address": {
            "1":"Address",
            "2":"Dirección"
        },
        "state": {
            "1":"State/Province",
            "2":"Estado/Provincia"
        },
        "zip_code": {
            "1":"Zip Code/Postal Code",
            "2":"Código postal"
        },
        "mat": {
            "1":"MAT Medication",
            "2":"Medicación MAT"
        },
        "pregnant": {
            "1":"Pregnant",
            "2":"Embarazada"
        },
        "payer": {
            "1":"Payer Type",
            "2":"Tipo de pagador"
        },
        "primary_sub": {
            "1":"Primary Substance",
            "2":"Sustancia principal"
        },
        "member": {
            "1":"Member ID",
            "2":"ID del miembro"
        },
        "city": {
            "1":"City",
            "2":"Ciudad"
        },
        "nhi": {
            "1":"NHI Identified",
            "2":"NHI Identificado"
        },
        "etherapy_pro": {
            "1":"Etherapy Program",
            "2":"Programa de Terapia"
        },
        "loc": {
            "1":"Level of Care",
            "2":"Nivel de atención"
        },
        "loc_start": {
            "1":"Level of Care Start Date",
            "2":"Nivel de atención Fecha de inicio"
        },
        "teams": {
            "1":"Teams",
            "2":"Equipos"
        },
        "groups": {
            "1":"Groups",
            "2":"Grupos"
        },
        "staff": {
            "1":"Staff",
            "2":"Personal"
        },
        "prime_staff": {
            "1":"Primary Staff",
            "2":"Personal principal"
        },
        "entity": {
            "1":"Entity/Location",
            "2":"Entidad/Ubicación"
        },
        "notes": {
            "1":"Notes",
            "2":"Notas"
        },
        "patient_lang": {
            "1":"Patient Language",
            "2":"Idioma del paciente"
        },
        "staff_name": {
            "1":"Staff Name",
            "2":"Nombre del Personal"
        },
        "insurance": {
            "1":"Insurance Provider",
            "2":"Proveedor de seguros"
        },
        "yes": {
            "1":"Yes",
            "2":"Sí"
        },
        "submit_message": {
            "1":"Clicking Submit will generate a SMS text message to the individual with an invitation to use the Connections App in the form of a download link. By agreeing to receive the invitation, the individual permits CHESS Health to use text messages or phone calls to offer technical and login assistance.",
            "2": "Al hacer clic Enviar, se generará un mensaje de texto SMS para la persona con una invitación para usar la aplicación Connections en forma de enlace de descarga. Al aceptar recibir la invitación, la persona también permite que CHESS Health use mensajes de texto o llamadas telefónicas para ofrecer asistencia técnica y de inicio de sesión."
        },
        "success": {
            "1": "Success! Sign-up Complete",
            "2": "¡Éxito! Registro completado"
        },
        "enrolled": {
            "1": "Enrolled!",
            "2": "¡Inscrito!"
        },
        "text_message": {
            "1": "Text Message Sent",
            "2": "Mensaje de texto enviado"
        },
        "text_message_link": {
            "1": "Message includes link to download the Connections app.",
            "2": "El mensaje incluye un enlace para descargar la aplicación Conexiones."
        },
        "next_steps": {
            "1": "Next steps to start using the App:",
            "2": "Próximos pasos para empezar a utilizar la App:"
        },
        "steps_view": {
            "1": "View text message",
            "2": "Ver mensaje de texto"
        },
        "steps_tap": {
            "1": "Tap link to find app",
            "2": "Toca el enlace para buscar la aplicación"
        },
        "steps_download": {
            "1": "Download the app",
            "2": "Descarga la aplicación"
        },
        "steps_login": {
            "1": "Login first-time with phone number",
            "2": "Inicie sesión por primera vez con número de teléfono"
        },
        "welcome_to_enrollment_form": {
            "1": "welcome to the Enrollment Form, the easy way to invite individuals to get the vital ",
            "2": "bienvenido al Formulario de Inscripción, la manera fácil de invitar a las personas a obtener la vital aplicación Conexiones."
        },
        "welcome_back": {
            "1": "Welcome back",
            "2": "Bienvenido de nuevo"
        },
        "link_no_valid": {
            "1": "The link is no longer valid.",
            "2": "El enlace ya no es válido.",
        },
        "problem": {
            "1": "There was a problem submitting the form.<br>Please contact support@connectionsapp.com for assistance.",
            "2": "Hubo un problema al enviar el formulario.<br>Por favor, contacte a support@connectionsapp.com para asistencia.",
        },
        "already_enrolled": {
            "1": "Already Enrolled! Text Message Sent.",
            "2": "¡Ya inscrito! Mensaje de texto enviado.",
        },
        "birth_phone": {
            "1": "Birthdate and phone number are the same as an existing account",
            "2": "La fecha de nacimiento y el número de teléfono son los mismos que los de una cuenta existente"
        },
        "close_window": {
            "1": "Please close window",
            "2": "Por favor, cierre la ventana"
        },
        "highest_level": {
            "1": "This is the highest level of Certification!",
            "2": "¡Este es el nivel más alto de Certificación!"
        }, 
        "app_enrollment_status": {
            "1": "Your App Enrollment Status",
            "2": "Su estado de inscripción en la aplicación" 
        },
        "all_time": {
            "1": "All Time",
            "2": "Todo, el tiempo"
        },
        "past_week": {
            "1": "Past Week",
            "2": "Última Semana"
        },
        "enroll_4_more": {
            "1" : "Enroll 4 more individuals to become ‘Certified’ status",
            "2" : "Inscriba a 4 personas más para alcanzar el estado de 'Certificado'",
        }, 
        "congrats": {
            "1": "Congrats!",
            "2": "¡Felicidades!"
        },
        "your_status": {
            "1": "Your Status:",
            "2": "Su Estado:"
        },
        "by_enrolling": {
            "1": "By enrolling",
            "2": "Al inscribir a"
        },
        "individuals_you_are": {
            "1": "individuals you are",
            "2": "personas, usted es"
        },
        "enroll": {
            "1": "Enroll",
            "2": "Inscriba"
        },
        "more_achieve": {
            "1": "more to achieve",
            "2": "más para lograr el estado de"
        },
        "need_help": {
            "1": "Have questions? Need help? Email ",
            "2": "¿Tiene preguntas? ¿Necesitas ayuda? Correo electrónico ",
        },
        "show_email" : {
            "1": "Show Email Field",
            "2": "Mostrar entrada de correo electrónico"
        },
        "success_questions": {
            "1": "Quick tip: Your text message might not appear in your main messages. If you're an iPhone user, check for a message in the 'Unknown Sender' text list, and if you're an Android user, peek in your spam folder. Look for anything mentioning 'Connections app'. It should be in your inbox within a minute. \n If you do not see it, please email support:",
            "2": "¿Tiene preguntas? ¿Necesita ayuda? Envíe un correo electrónico a"
        },
        "already_enrolled_not_onboarded": {
            "1": " is already enrolled to get Connections App",
            "2": " ya está registrado para obtener la aplicación Connections"
        },
        "based_phone_dob": {
            "1": "(based on phone number and DOB match)",
            "2": "(según la coincidencia del número de teléfono y la fecha de nacimiento)",
        },
        "already_enrolled_onboarded": {
            "1": " is already enrolled to get Connections App (and downloaded it before)",
            "2": " ya está registrado para usar Connections App (y la descargó anteriormente)"
        },
        "already_enrolled_not_onboarded_companion": {
            "1": " is already enrolled to get Companion App (based on phone number and DOB match)",
            "2": " ya está registrado para obtener la aplicación Connections (según la coincidencia del número de teléfono y la fecha de nacimiento)"
        },
        "already_enrolled_onboarded_companion": {
            "1": " is already enrolled to get Companion App (and downloaded it before)",
            "2": " ya está registrado para usar Connections App (y la descargó anteriormente)"
        },
        "message_text_sent": {
            "1": "A text message with a download link has just been sent to their phone",
            "2": "Se acaba de enviar un mensaje de texto con un enlace de descarga a su teléfono"
        },
        "message_text_sent_enrolled": {
            "1": "A new text message with a download link has just been sent to their phone",
            "2": "Se acaba de enviar un nuevo mensaje de texto con un enlace de descarga a su teléfono"
        },
        "message_text_sent_onboarded": {
            "1": "A new text message with a link to the app has just been sent to their phone",
            "2": "Se acaba de enviar un nuevo mensaje de texto a su teléfono con un enlace a la aplicación"
        },
        "download_link": {
            "1": "Tell them to look for the SMS message on their phone now and to click the download link ",
            "2": "Dígale que revise su teléfono ahora mismo para encontrar el mensaje SMS y que haga clic en el enlace de descarga "
        },
        "download_link_onboarded": {
            "1": "Tell them to look for the SMS message on their phone now and to click the link (opens or downloads app) ",
            "2": "Díganles que busquen el mensaje SMS en su teléfono ahora y que hagan clic en el enlace (abre o descarga la aplicación) "
        },
        "check_spam": {
            "1": "If they don’t see the text message, they should look in their ‘Spam’ list if they are an Android user or in their ‘Unknown Sender’ list if they are an iPhone user. They should look for anything that says ‘Connections App’",
            "2": "Si no ven el mensaje de texto, deben revisar su carpeta de ‘Spam’ si usan Android o la carpeta de ‘Remitentes desconocidos’ si usan iPhone. Deben buscar cualquier mensaje que diga ‘Conexiones App’"
        },
        "check_spam_companion": {
            "1": "If they don’t see the text message, they should look in their ‘Spam’ list if they are an Android user or in their ‘Unknown Sender’ list if they are an iPhone user. They should look for anything that says ‘Companion App’",
        },
        "contact": {
            "1": "Contact ",
            "2": "Para obtener ayuda, póngase en contacto con "
        },
        "assistance": {
            "1": " for assistance.",
            "2": "."
        },
        "patient_create":{
            "1": "Click To Download the Connections App",
            "2": "Haga clic para descargar la Aplicación de Conexiones"
        },
        "patient_create_companion":{
            "1": "Click To Download the Companion App",
            "2": "Haga clic para descargar la Aplicación de Compañero"
        },
        "connections_link":{
            "1": "https://link.connectionsapp.com",
            "2": "http://link.conexionesapp.com"
        },
        "login_first_time": {
            "1": "Login first-time with phone number",
            "2": "Inicia sesión por primera vez con tu número de teléfono"
        },
        "or": {
            "1": "or",
            "2": "o"
        },
        "open_text_message": {
            "1": "Open text message sent to you moments ago",
            "2": "Abre el mensaje de texto que te hemos enviado hace unos momentos"
        },
        "tap_link": {
            "1": "Tap link to find & download app",
            "2": "Pulsa el enlace para buscar y descargar la aplicación"
        },
        "contact_help": {
            "1": "Contact ",
            "2": "Ponte en contacto con "
        },
        "for_help": {
            "1": " for help",
            "2": " si necesitas ayuda"
        },
        "download_link_image": {
            "1": "connections-download-image.png",
            "2": "conexiones-download-image.png"
        },
        "video_url":{
            "1":"https://chessmediapublic.s3.us-west-2.amazonaws.com/screener-videos/Welcome_to_Connections_recovery_support_app_2025.mp4",
            "2":"https://chessmediapublic.s3.us-west-2.amazonaws.com/screener-videos/Bienvenido_a_Conexiones.mp4"
        },
        "duplicate_warning":{
            "1": "The individual you are trying to enroll is a potential duplicate in our system",
            "2": "La persona que intenta inscribir es un posible duplicado en nuestro sistema."
        },
        "warning_contact":{
            "1": "Please contact CHESS support with information around this setup to help",
            "2": "Comuníquese con el soporte de CHESS con información sobre esta configuración para obtener ayuda."
        }
    }
}
export {
    translations
}